import { useEffect, useState } from 'react';
import { PaginatedUserDocumentsDto } from '../../../commonTypes/user.types';
import { useContainer } from '../../useContainer';
import { ToastStateHandler, UserApi } from '../../../api';
import { useTranslation } from '../../useTranslation';

const DEFAULT_STATE: PaginatedUserDocumentsDto = {
    items: [],
    pageable: { direction: 'desc', page: 0, size: 10 },
    total: '0',
};

const useHttpGetUserDocumentsOnMount = (userSub: string, search?: string, categoryId?: string, page?: number) => {
    const userApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('newNotifications');
    const [documents, setDocuments] = useState<PaginatedUserDocumentsDto>(DEFAULT_STATE);
    const [areDocumentsReady, setAreDocumentsReady] = useState(true);
    const fecthDocuments = () => {
        const { exec, abort } = userApi.getUserDocuments({
            params: { userSub },
            query: {
                size: DEFAULT_STATE.pageable.size,
                page: page ?? DEFAULT_STATE.pageable.page,
                sort: 'createdAt',
                direction: DEFAULT_STATE.pageable.direction,
                ...(categoryId && { categoryId }),
                ...(search && { search }),
            },
            onSuccess: res => setDocuments(res.body),
            onError: () => toastHandler.push(`error`, t('common.error'), t('common.somethingWentWrong')),
            onFinally: () => setAreDocumentsReady(true),
        });
        exec();
        return abort;
    };
    useEffect(() => {
        const abort = fecthDocuments();
        return abort;
    }, [userSub, categoryId, search, page]);

    return { areDocumentsReady, documents, setDocuments, refetchDocuments: fecthDocuments };
};

export default useHttpGetUserDocumentsOnMount;
